import { render, staticRenderFns } from "./properties-component-navigation-links.vue?vue&type=template&id=c835b8e0&scoped=true"
import script from "./properties-component-navigation-links.vue?vue&type=script&lang=js"
export * from "./properties-component-navigation-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c835b8e0",
  null
  
)

export default component.exports